import React from 'react';
import { Row, Col, Card, Table } from 'react-bootstrap';
import { InfoRow } from './InfrastructureSectionPanel';

const InfrastructureMemoryPanel = ({ data }) => (
    <Row className="g-3">
        <Col md={6}>
            <Card className="border-0 bg-light">
                <Card.Body className="py-2 px-3">
                    <div className="small fw-semibold mb-2 text-secondary">Process Memory</div>
                    <InfoRow label="RSS" value={data.process?.rss} />
                    <InfoRow label="Heap Total" value={data.process?.heapTotal} />
                    <InfoRow label="Heap Used" value={data.process?.heapUsed} />
                    <InfoRow label="External" value={data.process?.external} />
                    <InfoRow label="Array Buffers" value={data.process?.arrayBuffers} />
                </Card.Body>
            </Card>
        </Col>
        <Col md={6}>
            <Card className="border-0 bg-light">
                <Card.Body className="py-2 px-3">
                    <div className="small fw-semibold mb-2 text-secondary">V8 Heap</div>
                    <InfoRow label="Total Heap" value={data.v8Heap?.totalHeapSize} />
                    <InfoRow label="Used Heap" value={data.v8Heap?.usedHeapSize} />
                    <InfoRow label="Heap Limit" value={data.v8Heap?.heapSizeLimit} />
                    <InfoRow label="Physical" value={data.v8Heap?.totalPhysicalSize} />
                    <InfoRow label="Available" value={data.v8Heap?.totalAvailableSize} />
                    <InfoRow label="Malloced" value={data.v8Heap?.mallocedMemory} />
                    <InfoRow label="Peak Malloced" value={data.v8Heap?.peakMallocedMemory} />
                    <InfoRow label="Native Contexts" value={data.v8Heap?.numberOfNativeContexts} />
                    <InfoRow label="Detached Contexts" value={data.v8Heap?.numberOfDetachedContexts} />
                </Card.Body>
            </Card>
        </Col>
        {data.heapSpaces?.length > 0 && (
            <Col xs={12}>
                <Card className="border-0 bg-light">
                    <Card.Body className="py-2 px-3">
                        <div className="small fw-semibold mb-2 text-secondary">Heap Spaces</div>
                        <div className="table-responsive">
                            <Table size="sm" className="mb-0 small">
                                <thead>
                                    <tr>
                                        <th>Space</th>
                                        <th>Size</th>
                                        <th>Used</th>
                                        <th>Available</th>
                                        <th>Physical</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {data.heapSpaces.map((s, i) => (
                                        <tr key={i}>
                                            <td className="text-muted">{s.name}</td>
                                            <td>{s.size}</td>
                                            <td>{s.used}</td>
                                            <td>{s.available}</td>
                                            <td>{s.physicalSize}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        </div>
                    </Card.Body>
                </Card>
            </Col>
        )}
    </Row>
);

export default InfrastructureMemoryPanel;
